import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import Contact14 from './contact14'
import './contact10.css'

const Contact10 = (props) => {
  return (
    <div className="contact10-container thq-section-padding">
      <div className="contact10-max-width thq-section-max-width">
        <div className="contact10-content1 thq-flex-row">
          <div className="contact10-content2">
            <h2 className="thq-heading-2">
              {props.heading1 ?? (
                <Fragment>
                  <span className="contact10-text21">Contact Us</span>
                </Fragment>
              )}
            </h2>
            <p className="thq-body-large">
              {props.content1 ?? (
                <Fragment>
                  <span className="contact10-text20">
                    Have questions or ready to get started? Reach out to us for
                    more information.
                  </span>
                </Fragment>
              )}
            </p>
          </div>
        </div>
        <div className="contact10-content3 thq-flex-row"></div>
      </div>
      <Contact14
        link1={
          <Fragment>
            <span className="contact10-text12">Start new chat</span>
          </Fragment>
        }
        email1={
          <Fragment>
            <span className="contact10-text13">
              bizsetup@allstreamglobal.com
            </span>
          </Fragment>
        }
        phone1={
          <Fragment>
            <span className="contact10-text14">+971 55 548 8775</span>
          </Fragment>
        }
        address1={
          <Fragment>
            <span className="contact10-text15">Abu Dhabi, UAE</span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="contact10-text16">Email</span>
          </Fragment>
        }
        heading2={
          <Fragment>
            <span className="contact10-text17">Whatsapp Chat</span>
          </Fragment>
        }
        heading3={
          <Fragment>
            <span className="contact10-text18">Phone</span>
          </Fragment>
        }
        heading4={
          <Fragment>
            <span className="contact10-text19">Office</span>
          </Fragment>
        }
      ></Contact14>
    </div>
  )
}

Contact10.defaultProps = {
  content1: undefined,
  heading1: undefined,
}

Contact10.propTypes = {
  content1: PropTypes.element,
  heading1: PropTypes.element,
}

export default Contact10
